import { useState, useEffect } from 'react'
import useTranslate from '../../../i18n/useTranslate'
import useLookupService from '../../lookup/useLookupService'

export type OptType = {
    label: string
    value: string
}

const useFaculty = () => {
    const translate = useTranslate()
    const callLookup = useLookupService()
    const [faculty, setFaculty] = useState<OptType[]>([])

    const getFaculty = async () => {
        const res = await callLookup.callFacultyLut()
        const formatedData = res.result.map((itm) => {
            return {
                label: translate.languageStore.currentLanguage === translate.languageKey.th ? itm.name_th : itm.name_en,
                value: `${itm.id}`,
                irb: `${itm.irb}`,
            }
        })
        setFaculty(formatedData)
    }

    useEffect(() => {
        getFaculty()
    }, [translate.languageStore.currentLanguage])

    return { faculty }
}

export default useFaculty
